import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { toggleDagSchedulingInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { ToggleDagSchedulingRequest } from '@/entities/dag/domain/types';

export const toggleDagSchedulingApi = async ({ dagUuid, enabled }: ToggleDagSchedulingRequest): Promise<void> => {
  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('fast');
    toggleDagSchedulingInMockStore({ dagUuid, enabled });
    return;
  }

  await cycloneApiClient.patch(`/dags/${dagUuid}/scheduling`, { enabled });
};
